import React, { useState, useRef } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { FiActivity, FiUsers, FiBarChart2 } from "react-icons/fi";
import {
  Bars3Icon,
  XMarkIcon,
  UserIcon,
  ClockIcon,
  ChartBarIcon,
  CogIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import logo from "../img/logo.png";

function Dashboard() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    if (isOpen) setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="relative h-screen flex flex-col md:flex-row">
      {/* Sidebar Toggle Button for Mobile */}
      <div className=" bg-blue50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden fixed top-4 left-4 z-50 bg-blue-600 text-white p-2 rounded-full shadow-lg"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed md:relative top-0 left-0 h-full bg-gradient-to-r from-[#3a97d2] via-[#2b7d99] to-[#1f5f77] p-4 flex flex-col items-center transition-all duration-500 text-white shadow-lg z-50 w-64  ${
          isOpen
            ? "translate-x-0 md:w-[15rem]"
            : "-translate-x-full md:translate-x-0 md:w-20"
        }`}
      >
        {!isOpen && (
          <button
            onClick={() => setIsOpen(!isOpen)}
            className=" fixed top-4 left-4 z-50   text-white p-2 rounded-full shadow-lg mx-1 py-2"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        )}
        <div className="flex w-full justify-between md:justify-center items-center mb-6">
          {isOpen && (
            <img src={logo} alt="Logo" className="h-8 object-contain" />
          )}
          {isOpen && (
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="  text-white focus:outline-none mt-2 ml-2"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          )}
        </div>

        <nav className="space-y-4 w-full h-screen mt-10">
          {/* <Link
            to="/dashboard/user-analysis"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <UserIcon className="h-6 w-6" />
            {isOpen && <span>User Analysis</span>}
          </Link> */}
          <Link
            to="/dashboard/overall-analysis"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <CogIcon className="h-6 w-6" />
            {isOpen && <span>Overall Analysis</span>}
          </Link>
          <Link
            to="/dashboard/attendance"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <ClockIcon className="h-6 w-6" />
            {isOpen && <span>Attendance</span>}
          </Link>
          {/* <Link
            to="/dashboard/user-attendance"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <FiUsers className="h-6 w-6" />
            {isOpen && <span>User-Attendance</span>}
          </Link> */}
          <Link
            to="/dashboard/detailed-utilization"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <FiBarChart2 className="h-6 w-6" />
            {isOpen && <span>Utilization</span>}
          </Link>
          <Link
            to="/dashboard/utilisation-quick-view"
            onClick={handleLinkClick}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <FiActivity className="h-6 w-6" />
            {isOpen && <span>Utilization Quick View</span>}
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center space-x-4 p-3 rounded-md hover:scale-105"
          >
            <ArrowRightOnRectangleIcon className="h-6 w-6" />
            {isOpen && <span>Logout</span>}
          </button>
        </nav>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 md:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Main Content */}
      <div
        className={`w-full h-screen md:${
          isOpen ? "ml-20" : "ml-10"
        } overflow-y-auto p-4`}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default Dashboard;
